var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowExternalWhite = function SvgArrowExternalWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.817 7.583 0 6.767l5.6-5.6H.583V0h7v7H6.417V1.983z"
  })));
};
export { SvgArrowExternalWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIHZpZXdCb3g9IjAgMCA4IDgiIGZpbGw9Im5vbmUiPgogIDxwYXRoIGQ9Ik0wLjgxNjY2NyA3LjU4MzMzTDAgNi43NjY2N0w1LjYgMS4xNjY2N0gwLjU4MzMzM1YwSDcuNTgzMzNWN0g2LjQxNjY3VjEuOTgzMzNMMC44MTY2NjcgNy41ODMzM1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPg==";